import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TopListingsService {
  private backendUrl: string = environment.backendUrl;

  constructor(
    private http: HttpClient
  ) { }

  getTopPromotionTools(params: any = {}) {
    return this.http.get(`${this.backendUrl}/reports/top-banners`, {
      params
    });
  }

  getTopDownlines(params: any = {}) {
    return this.http.get(`${this.backendUrl}​/reports/downlines`, {
      params
    });
  }

}
